// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu{background:#f5f4fc;padding:1rem}.menu-item{padding:12px 0;cursor:pointer;color:#303030;font-family:Avenir;font-size:12px;font-weight:600}.active{color:#7100da}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
